/**
 * Utilidades de formateo para formularios de declaración de renta.
 * Funciones puras sin estado - el contexto de empresa se maneja en los hooks y servicios.
 */

/**
 * Formatea un número como moneda chilena (con puntos como separador de miles)
 */
const formatCurrency = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '';
  const isNegative = num < 0;
  const absStr = Math.abs(Math.round(num)).toString();
  const formatted = absStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return isNegative ? `-${formatted}` : formatted;
};

/**
 * Parsea un string formateado como moneda a número
 */
const parseCurrency = (str) => {
  if (!str) return 0;
  const cleaned = str.replace(/\./g, '').replace(/[^0-9-]/g, '');
  return parseInt(cleaned, 10) || 0;
};

/**
 * Redondea un número a la cantidad de decimales indicada
 */
const roundTo = (value, decimals = 0) => {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
};

/**
 * Trunca un número a la cantidad de decimales indicada (sin redondear)
 */
const truncTo = (value, decimals = 0) => {
  const factor = Math.pow(10, decimals);
  return Math.trunc(value * factor) / factor;
};

module.exports = { formatCurrency, parseCurrency, roundTo, truncTo };
